import React from 'react';
import { Users, UserCheck, UserX, ShieldCheck, KeyRound } from 'lucide-react';

interface Props {
  totalUsuarios: number;
  totalAtivos: number;
  totalInativos: number;
  totalComAuth: number;
  onOpenMyPasswordModal?: () => void;
}

export const UsuariosStatsCards: React.FC<Props> = ({
  totalUsuarios,
  totalAtivos,
  totalInativos,
  totalComAuth,
  onOpenMyPasswordModal
}) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-xs flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center font-bold">
          <Users className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-black text-slate-900">{totalUsuarios}</div>
          <div className="text-xs font-semibold text-slate-500">Total Usuários</div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-xs flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center font-bold">
          <UserCheck className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-black text-slate-900">{totalAtivos}</div>
          <div className="text-xs font-semibold text-emerald-600">Ativos</div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-xs flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center font-bold">
          <UserX className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-black text-slate-900">{totalInativos}</div>
          <div className="text-xs font-semibold text-amber-600">Inativos</div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-xs flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center font-bold">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <div>
          <div className="text-2xl font-black text-slate-900">{totalComAuth}</div>
          <div className="text-xs font-semibold text-purple-600">Supabase Auth</div>
        </div>
      </div>

      {onOpenMyPasswordModal && (
        <button
          type="button"
          onClick={onOpenMyPasswordModal}
          className="bg-slate-900 hover:bg-slate-800 text-white p-4 rounded-xl border border-slate-700 shadow-xs flex items-center gap-3 transition text-left col-span-2 lg:col-span-1"
        >
          <div className="w-10 h-10 rounded-lg bg-amber-500/20 text-amber-400 flex items-center justify-center font-bold border border-amber-500/30">
            <KeyRound className="w-5 h-5" />
          </div>
          <div>
            <div className="text-xs font-black text-amber-400">Minhas Credenciais</div>
            <div className="text-[11px] text-slate-300">Alterar minha senha</div>
          </div>
        </button>
      )}
    </div>
  );
};
